export default __webpack_public_path__ + "static/media/icon-eleventh-card.7bea31c1.svg";